// Client-side speed bump against rapid-fire login guessing — NOT a
// substitute for real protection (Firebase's own backend already throttles
// auth requests server-side, and anyone can clear localStorage to reset
// this). This exists purely to slow down casual automated attempts and
// give the user visible feedback, since the backend throttling is silent.
const MAX_ATTEMPTS = 5;
const LOCKOUT_MS = 60 * 1000;
const STORAGE_PREFIX = "tb_login_attempts_";

function keyFor(email) {
  return STORAGE_PREFIX + email.trim().toLowerCase();
}

function read(email) {
  try {
    return JSON.parse(localStorage.getItem(keyFor(email))) || { count: 0, lockedUntil: 0 };
  } catch {
    return { count: 0, lockedUntil: 0 };
  }
}

// Returns remaining lockout seconds if currently locked out, else 0.
export function getLoginLockoutSeconds(email) {
  if (!email) return 0;
  const { lockedUntil } = read(email);
  const remaining = lockedUntil - Date.now();
  return remaining > 0 ? Math.ceil(remaining / 1000) : 0;
}

export function recordFailedLogin(email) {
  if (!email) return 0;
  const state = read(email);
  const count = state.count + 1;
  const lockedUntil = count >= MAX_ATTEMPTS ? Date.now() + LOCKOUT_MS : 0;
  localStorage.setItem(keyFor(email), JSON.stringify({ count: lockedUntil ? 0 : count, lockedUntil }));
  return lockedUntil ? Math.ceil(LOCKOUT_MS / 1000) : 0;
}

export function clearLoginAttempts(email) {
  if (!email) return;
  localStorage.removeItem(keyFor(email));
}
